import { all, call, takeLatest } from 'redux-saga/effects';

import { authSaga } from './auth/auth.saga';
import { projectSaga } from './survey/project.saga';
import common from './common';
import admin from './admin';
import NotificationsSlice from '../common/slices/NotificationsSlice';
import NotificationService from '../common/services/NotificationService';

function* popNotification(action: { payload: number }) {
    yield call(NotificationService.removeNotification, action.payload);
}

export function* rootSaga() {
    yield all([
        ...authSaga,
        ...projectSaga,
        ...common,
        ...admin,
        takeLatest(NotificationsSlice.actions.pop.type as any, popNotification),
    ]);
}
